import React from "react";
import { Routes, Route } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import fondo from "../../assets/img/fondo.png";
import AdminLayout from "./AdminLayout";
import AdminPage from "./AdminPage";

import GestionarUsuarios from "./usuarios/GestionarUsuarios";
import GestionarVendedores from "./usuarios/GestionarVendedores";
import Auditoria from "./Auditoria";

import GestionarSolicitudes from "./contratos/AdminSolicitudesPage";
import GestionarContratos from "./contratos/ContratosTable";
import GestionarSolicitudesCaducadas from "./contratos/SolicitudesTable";

import GestionarPagos from "./pagos/PagosPendientes";
import GestionarCuotas from "./pagos/ReportePagosCuotas";
import HistorialPagosDeContado from "./pagos/PagosDeContado";
import HistorialPagosFinanciados from "./pagos/PagosFinanciados";
import HistorialPagos from "./pagos/HistorialPagos";

import GestionarProductos from "./planes/PlanesProductos";
import GestionarServicios from "./planes/PlanesServicios";

import GestionarPlanes from "./planes/PlanesTable";
import GestionarParcelas from "./planes/InventarioParcelas";
import GestionarColumbarios from "./planes/Columbarios";
import GestionarPlanesFunerarios from "./planes/PlanesFunerariosTable";

const AdminDashboard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundImage: `url(${fondo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <CssBaseline />
      <Header />
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <AdminLayout />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 2,
            overflow: "auto",
          }}
        >
          <Routes>
            <Route index element={<AdminPage />} />
            <Route path="gestionar-usuarios" element={<GestionarUsuarios />} />
            <Route
              path="gestionar-vendedores"
              element={<GestionarVendedores />}
            />
            <Route path="auditoria" element={<Auditoria />} />
            <Route
              path="gestionar-solicitudes"
              element={<GestionarSolicitudes />}
            />
            <Route
              path="gestionar-contratos"
              element={<GestionarContratos />}
            />
            <Route
              path="gestionar-solicitudes-caducadas"
              element={<GestionarSolicitudesCaducadas />}
            />
            <Route path="gestionar-pagos" element={<GestionarPagos />} />
            <Route path="gestionar-cuotas" element={<GestionarCuotas />} />
            <Route
              path="historial-pagos-contado"
              element={<HistorialPagosDeContado />}
            />
            <Route
              path="historial-pagos-financiados"
              element={<HistorialPagosFinanciados />}
            />
            <Route path="historial-ingresos" element={<HistorialPagos />} />

            <Route path="gestionar-productos" element={<GestionarProductos />} />
            <Route path="gestionar-servicios" element={<GestionarServicios />} />
            <Route path="gestionar-planes" element={<GestionarPlanes />} />
            <Route path="gestionar-parcelas" element={<GestionarParcelas />} />
            <Route
              path="gestionar-columbarios"
              element={<GestionarColumbarios />}
            />
            <Route
              path="gestionar-planes-funerarios"
              element={<GestionarPlanesFunerarios />}
            />
          </Routes>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default AdminDashboard;
